<template>
    <div class="app-container">
        <el-skeleton v-if="pageLoading" :rows="12" animated />
        <div v-else class="form-box">
            <el-form label-position="right" ref="form" :rules="rules" :model="form" label-width="500px"  >
                <p>基本设置</p>
                <el-form-item label="版本号" prop="version">
                    <el-input v-model="form.version" placeholder="请输入版本号"></el-input>
                </el-form-item>


                <el-form-item label="注册赠送能量数量" prop="registerGiveChatCount">
                    <el-input v-model="form.registerGiveChatCount" placeholder="请输入次数"></el-input>
                </el-form-item>
                <el-form-item label="注册赠送绘画次数" prop="registerGiveChatCount">
                    <el-input v-model="form.registerGiveCreative" placeholder="请输入次数"></el-input>
                </el-form-item>
                <el-form-item label="订单支付过期时间(分钟)" prop="orderPayExpireTime">
                    <el-input v-model="form.orderPayExpireTime" placeholder="请输入分钟"></el-input>
                </el-form-item>
                <el-form-item label="最小提现金额(元)" prop="minWithdrawalAmount">
                    <el-input v-model="form.minWithdrawalAmount" placeholder="请输入金额"></el-input>
                </el-form-item>
                <el-form-item label="绘画一张图的能量花费" prop="drawEnergy">
                    <el-input v-model="form.drawEnergy" placeholder="请输入数量"></el-input>
                </el-form-item>

                <el-form-item label="小程序分享路径" prop="drawEnergy">
                    <el-input v-model="form.wxminiCode" placeholder="请输入路径"></el-input>
                </el-form-item>
                <br>
                <br>
                <br>

                <p>代理设置</p>
                <el-form-item label="分销奖励比率" prop="distributionRewardRatio">
                    <el-input v-model="form.distributionRewardRatio" placeholder="请输入比率"></el-input>
                </el-form-item>

                <el-form-item label="金牌代理奖励(最大代数,奖励比率)" prop="agentRewardMetals">
                    <el-input v-model="form.agentRewardMetals" placeholder="请输入比率"></el-input>
                </el-form-item>

                <el-form-item label="银牌代理奖励(最大代数,奖励比率)" prop="agentRewardSilver">
                    <el-input v-model="form.agentRewardSilver" placeholder="请输入比率"></el-input>
                </el-form-item>

                <el-form-item label="会员充能折扣（金牌会员，银牌会员，普通会员）" prop="memberDiscount">
                    <el-input v-model="form.memberDiscount" placeholder="请输入折扣"></el-input>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" :loading="saving" @click="handleSubmit('form')">保存</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
import request from "@/utils/request"

export default {
    data: () => ({
        rules: {
            version: [
                { required: true, message: '请输入版本号', trigger: 'blur' }
            ],
            registerGiveCreative: [
                { required: true, message: '请输入次数', trigger: 'blur' }
            ],
            registerGiveChatCount: [
                { required: true, message: '请输入次数', trigger: 'blur' }
            ],
            orderPayExpireTime: [
                { required: true, message: '请输入分钟', trigger: 'blur' }
            ],
            minWithdrawalAmount: [
                { required: true, message: '请输入金额', trigger: 'blur' }
            ],
            drawEnergy: [
                { required: true, message: '请输入数量', trigger: 'blur' }
            ],
            distributionRewardRatio: [
                { required: true, message: '请输入比率', trigger: 'blur' }
            ],
            agentRewardMetals: [
                { required: true, message: '请输入比率', trigger: 'blur' }
            ],
            agentRewardSilver: [
                { required: true, message: '请输入比率', trigger: 'blur' }
            ],
            memberDiscount: [
                { required: true, message: '请输入折扣', trigger: 'blur' }
            ],
            wxminiCode: [
                { required: true, message: '请输入路径', trigger: 'blur' }
            ]

            
        },
        form: {
            version: '',
            //新
            registerGiveChatCount:'',
            orderPayExpireTime:'',
            minWithdrawalAmount:'',
            drawEnergy:'',
            distributionRewardRatio:'',
            agentRewardMetals:'',
            agentRewardSilver:'',
            memberDiscount:'',
            wxminiCode:'',
            registerGiveCreative:'',
        },
        keyAll:"registerGiveChatCount,orderPayExpireTime,minWithdrawalAmount,drawEnergy,distributionRewardRatio,agentRewardMetals,agentRewardSilver,memberDiscount,wxminiCode,registerGiveCreative",
        pageLoading: false,
        saving: false
    }),
    methods: {
        getProfile() {
            request({
                url: "/api/backend/settings/get",
                method: "get",
                params: {
                    key: "version"
                }
            }).then(res => {
                this.form.version = res.data.value || "";  //微信号
                this.pageLoading = false
            });
        },
        getKeyAll() {
            request({
                url: "/api/backend/settings/getAllKey",
                method: "get",
                params: {
                    key: this.keyAll
                }
            }).then(res => {

                this.form.registerGiveChatCount = res.data.find(item => item.key ==="registerGiveChatCount").value
                this.form.orderPayExpireTime  = res.data.find(item => item.key ==="orderPayExpireTime").value
                this.form.minWithdrawalAmount = res.data.find(item => item.key ==="minWithdrawalAmount").value
                this.form.drawEnergy  = res.data.find(item => item.key ==="drawEnergy").value
                this.form.distributionRewardRatio = res.data.find(item => item.key ==="distributionRewardRatio").value
                this.form.agentRewardMetals = res.data.find(item => item.key ==="agentRewardMetals").value
                this.form.agentRewardSilver = res.data.find(item => item.key ==="agentRewardSilver").value
                this.form.memberDiscount  = res.data.find(item => item.key ==="memberDiscount").value
                this.form.wxminiCode  = res.data.find(item => item.key ==="wxminiCode").value
                this.form.registerGiveCreative  = res.data.find(item => item.key ==="registerGiveCreative").value

                this.pageLoading = false

            });
        },

        handleSubmit(formName) {
          this.$confirm("此操作将修改类目信息，是否继续？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then((result) => {
                  this.onSave(formName)
            })
            .catch((err) => {
              this.$notify.info("已取消");
z            });
        },

        onSave(formName) {
            this.$refs[formName].validate(async (valid) => {
                if (valid) {
                    try {
                        this.saving = true
                        await request({
                            url: "/api/backend/settings/newStore",
                            method: "post",
                            data: {
                                key:this.form
                            }
                        })
                        this.$message({
                            message: "已保存!",
                            type: 'success'
                        });
                    } catch {
                        this.$message.error('出错了!');
                    } finally {
                        this.saving = false
                    }
                    this.getProfile()
                    this.getKeyAll()
                }
            });
        }
    },
    beforeMount() {
        this.getProfile()
        this.getKeyAll()
    }
}
</script>

<style lang="scss" scoped>
.form-box {
    max-width: 900px;
}
</style>